import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditAssetForm from './EditAssetForm'
import ModalHeader from './ModalHeader'
import AssetLoader from './_load/AssetLoader'

const EditAssetModal = props => {
  return (
    <ControlledModal width="42rem" {...props}>
      <PermissionChecker module="place" name="edit">
        <ModalHeader />
        <AssetLoader>
          <EditAssetForm />
        </AssetLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditAssetModal
